import orderBy from "lodash/orderBy";

export const featureList = [
    {
        key: "projectsCount",
        name: "Projects Count",
        getDescription: (count) => `${count} ${count > 1 ? "Products" : "Product"}`,
        pricingTable: true,
        priceComparison: false,
        type: "number",
        displayOrder: 1,
    },
    {
        key: "modelsConfigurationLimit",
        name: "Models Configuration Limit",
        getDescription: (count) => `${count} ${count > 1 ? "Model" : "Models"}`,
        pricingTable: false,
        priceComparison: false,
        type: "number",
        displayOrder: 10,
    },
    // {
    //   key: "viewsCount",
    //   name: "Views Count",
    //   getDescription: (count) =>
    //     `${count} ${count > 1 ? "Monthly Views" : "View"}`,
    //   pricingTable: true,
    //   priceComparison: false,
    //   type: "number",
    //   displayOrder: 2,
    // },
    {
        key: "storageAllowedMB",
        name: "Storage Allowed",
        getDescription: (count) => `${count} MB Cloud Space`,
        pricingTable: true,
        priceComparison: false,
        type: "number",
        displayOrder: 3,
    },
    {
        key: "embeddedViewer",
        name: "Embedded Viewer",
        getDescription: () => "Embedded Viewer",
        pricingTable: true,
        priceComparison: true,
        type: "boolean",
    },
    // {
    //   key: "arCardProject",
    //   name: "AR Card Project",
    //   getDescription: () => "AR Card Project",
    //   pricingTable: true,
    //   priceComparison: false,
    //   type: "boolean",
    //   displayOrder: 4,
    // },
    {
        key: "productVisualizerProject",
        name: "Product Visualizer Project",
        getDescription: () => "Free 3D Store",
        pricingTable: true,
        priceComparison: false,
        type: "boolean",
        displayOrder: 5,
    },
    {
        key: "ecommerceProject",
        name: "Ecommerce Project",
        getDescription: () => "Ecommerce Project",
        pricingTable: true,
        priceComparison: false,
        type: "boolean",
        displayOrder: 6,
    },
    {
        key: "productGallery",
        name: "Product Gallery",
        getDescription: () => "Product Gallery",
        pricingTable: false,
        priceComparison: true,
        type: "boolean",
        displayOrder: 7,
    },
    {
        key: "productVariants",
        name: "Product Variants",
        getDescription: () => "Product Variants",
        pricingTable: false,
        priceComparison: true,
        type: "boolean",
        displayOrder: 8,
    },
    {
        key: "productDimensions",
        name: "Product Dimensions",
        getDescription: () => `Product Dimensions`,
        priceComparison: true,
        pricingTable: false,
        type: "boolean",
        displayOrder: 9,
    },
    {
        key: "whiteLabel",
        name: "White Label",
        getDescription: () => "Remove Bitbute branding",
        pricingTable: false,
        priceComparison: true,
        type: "boolean",
        displayOrder: 9,
    },
    {
        key: "projectReports",
        name: "Project Reports",
        getDescription: () => "Project Reports",
        pricingTable: false,
        priceComparison: true,
        type: "boolean",
        displayOrder: 10,
    },
    {
        key: "customARButton",
        name: "Custom AR Button",
        getDescription: () => "Custom AR Button",
        pricingTable: false,
        priceComparison: true,
        type: "boolean",
        displayOrder: 11,
    },
];

export const buildCurrentFeatures = (featuresArr, currentUsage) => {
    const featuresObject = {};

    featuresArr.forEach((feature) => {
        const { name, value } = feature;

        featuresObject[name] = value;
    });

    return {
        whiteLabel: {
            shouldAllow: () => {
                return featuresObject.whiteLabel;
            },
        },
        productVariants: {
            shouldAllow: () => {
                return featuresObject.productVariants;
            },
        },
        projectReports: {
            shouldAllow: () => {
                return featuresObject.projectReports;
            },
        },
        projectsCount: {
            shouldAllow: () => {
                return featuresObject.projectsCount
                    ? featuresObject.projectsCount > (currentUsage.activeProjects || 0)
                    : false;
            },
        },
        viewsCount: {
            shouldAllow: () => {
                return featuresObject.viewsCount
                    ? featuresObject.viewsCount > (currentUsage.totalViews || 0)
                    : false;
            },
        },
        storageAllowedMB: {
            shouldAllow: () => {
                return featuresObject.storageAllowedMB
                    ? featuresObject.storageAllowedMB > (currentUsage.totalStorageMb || 0)
                    : false;
            },
        },
        arCardProject: {
            shouldAllow: () => {
                return featuresObject.arCardProject;
            },
        },
        productVisualizerProject: {
            shouldAllow: () => {
                return featuresObject.productVisualizerProject;
            },
        },
        ecommerceProject: {
            shouldAllow: () => {
                return featuresObject.ecommerceProject;
            },
        },
        productGallery: {
            shouldAllow: () => {
                return featuresObject.productGallery;
            },
        },
        productDimensions: {
            shouldAllow: () => {
                return featuresObject.productDimensions;
            },
        },
        customARButton: {
            shouldAllow: () => {
                return featuresObject.customARButton;
            },
        },
    };
};

export const getMappedPlansAndFeatures = (standardPlans, userPlan) => {
    let allPlans = [...standardPlans];
    if (userPlan?.type === "CUSTOM") {
        allPlans = [...standardPlans, userPlan];
    }
    const mapPlansAndFeatures = allPlans.map((plan) => {
        const { features } = plan;
        const mappedFeatures = features.map((f) => {
            const { name, value } = f;
            const findFeature = featureList.find((f) => f.key === name);
            if (!findFeature) {
                return {}
            }
            return {
                ...findFeature,
                value,
                description: findFeature.getDescription(value),
            };
        });
        const pricingTable = mappedFeatures.filter((f) => f.pricingTable);
        const orderedPricingTable = orderBy(pricingTable, "displayOrder");
        const featureComparison = mappedFeatures.filter((f) => f.priceComparison);
        const orderedFeatureComparison = orderBy(featureComparison, "displayOrder");

        return {
            ...plan,
            features: {
                pricingTable: orderedPricingTable,
                featureComparison: orderedFeatureComparison,
            },
        };
    });
    const orderedPlans = orderBy(
        mapPlansAndFeatures,
        (plan) => plan?.prices[0]?.prices[0]?.value
    );
    if (userPlan?.type === "CUSTOM") {
        const customPlan = orderedPlans.find((p) => p.type === "CUSTOM");
        const arrangedPlan = orderedPlans.filter((p) => p.type !== "SHOPIFY");
        arrangedPlan.unshift(customPlan);
        return arrangedPlan;
    }
    return orderedPlans;
};

export const getFeatureDataType = (featureKey) => {
    const type = featureList.find((f) => f.key === featureKey)?.type;
    return type;
};

export const findNextRecommendationPlan = (
    standardPlans,
    userPlan,
    usages = {},
    requiredFeature = ""
) => {
    let recommendedPlan = "";
    userPlan = {
        features: [],
        prices: [],
        ...userPlan
    }

    if (requiredFeature) {
        const requiredFeatureType = getFeatureDataType(requiredFeature);

        const upgradePlanTo = standardPlans.find((plan) => {
            const filteredByTypeAndValue = plan.features.filter((feature) => {
                const currentFeatureType = getFeatureDataType(feature.name);
                const valueOfRequiredFeatureInUserPlan = userPlan.features.find(
                    (f) => f.name === requiredFeature
                )?.value;

                if (requiredFeatureType === "number") {
                    const requiredValue =
                        requiredFeature === "storageAllowedMB"
                            ? usages.totalStorageMb
                            : valueOfRequiredFeatureInUserPlan;
                    return (
                        currentFeatureType === requiredFeatureType &&
                        feature.value &&
                        feature.value > requiredValue
                    );
                }

                return currentFeatureType === requiredFeatureType && feature.value;
            });

            return filteredByTypeAndValue
                .map((f) => f.name)
                .includes(requiredFeature);
        });

        recommendedPlan = upgradePlanTo?.name;
    }

    if (!requiredFeature || !recommendedPlan) {
        const userPrice = userPlan.prices[0]?.prices[0]?.value;

        const nextPlan = standardPlans.find((item) => {
            const planPrice = item.prices[0]?.prices[0]?.value;
            return planPrice > userPrice;
        });

        recommendedPlan = nextPlan ? nextPlan.name : null;
    }

    return recommendedPlan;
};

export const allFeaturesKeys = featureList.map((r) => r.key);

export const getFeatureType = (featureName) => {
    return featureList.find((f) => f.key === featureName)?.type;
};

export const getFeature = (featureNameToFind, plan) => {
    const foundFeature = (plan?.features || []).find(
        (feature) => feature.name === featureNameToFind
    );
    return foundFeature;
};
